/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_In_StoreInputs */

const vi_customer_in_store = /** @type {(inputs: Customer_In_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mua tại quầy`)
};

/**

* @param {Customer_In_StoreInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_in_store = /** @type {((inputs?: Customer_In_StoreInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_In_StoreInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_in_store(inputs)
});